import React, { useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { CheckCircle, Calendar, Zap, Users, TrendingUp, Download, Sparkles, Target, Layers, Clock, X, DollarSign, Rocket, BarChart, Shield, Briefcase, Heart, Lightbulb, Star, ArrowRight, Award, FileText, RefreshCw } from 'lucide-react';

const Home = () => {
  const SKOOL_URL = "https://www.skool.com/digitale-produkt-akademie-6761";
  const [showPayPalModal, setShowPayPalModal] = React.useState(false);
  const [paypalLoaded, setPaypalLoaded] = React.useState(false);

  useEffect(() => {
    // Load PayPal SDK only once
    if (!paypalLoaded && !window.paypal) {
      const script = document.createElement('script');
      script.src = "https://www.paypal.com/sdk/js?client-id=Ad6g_E82-HFkgey76aVhiwKMqYaOFhGzR3gubIhrkrdL84QZ6aH_jotqh_s8NdPdf8XODREGFnYrxiLU&vault=true&intent=subscription";
      script.async = true;
      script.setAttribute('data-sdk-integration-source', 'button-factory');
      
      script.onload = () => {
        setPaypalLoaded(true);
      };
      
      script.onerror = () => {
        console.error('Failed to load PayPal SDK');
      };
      
      document.body.appendChild(script);
    }
  }, [paypalLoaded]);

  useEffect(() => {
    // Render PayPal button when modal opens and SDK is loaded
    if (showPayPalModal && window.paypal && paypalLoaded) {
      const container = document.getElementById('paypal-button-container');
      if (container && container.childElementCount === 0) {
        window.paypal.Buttons({
          style: {
            shape: 'pill',
            color: 'gold',
            layout: 'vertical',
            label: 'subscribe'
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              plan_id: 'P-7NC06550XG055645BNERZ75A'
            });
          },
          onApprove: function(data, actions) {
            alert('Vielen Dank! Deine Mitgliedschaft wurde aktiviert. Subscription ID: ' + data.subscriptionID);
            setShowPayPalModal(false);
            // Redirect to Skool Community after successful subscription
            setTimeout(() => {
              window.location.href = SKOOL_URL;
            }, 2000);
          },
          onCancel: function(data) {
            console.log('PayPal subscription cancelled');
            setShowPayPalModal(false);
          },
          onError: function(err) {
            console.error('PayPal error:', err);
            alert('Es gab ein Problem mit der Zahlung. Bitte versuche es erneut.');
          }
        }).render('#paypal-button-container');
      }
    }
  }, [showPayPalModal, paypalLoaded]);

  useEffect(() => {
    // Listen for header button click
    const handleOpenModal = () => {
      setShowPayPalModal(true);
    };
    
    window.addEventListener('openPayPalModal', handleOpenModal);
    
    return () => {
      window.removeEventListener('openPayPalModal', handleOpenModal);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-in-section').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const testimonials = [
    {
      name: "Julia Schwarz",
      role: "Social Media Freelancerin",
      text: "Pixel56 hat meinen Workflow komplett verändert. Ich spare täglich 2-3 Stunden und kann mich endlich auf Strategie konzentrieren statt auf Design. Die Templates sind Gold wert!",
      image: "https://images.unsplash.com/photo-1655249481446-25d575f1c054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc2MjgwMTI3MHww&ixlib=rb-4.1.0&q=85",
      type: "image"
    },
    {
      name: "Michael Weber",
      role: "Inhaber, Weber Dachdeckerei",
      text: "Als Handwerker hatte ich nie Zeit für Social Media. Mit den Templates poste ich jetzt täglich professionelle Inhalte in unter 10 Minuten. Meine Auftragslage hat sich verdoppelt!",
      image: "https://images.unsplash.com/photo-1629507208649-70919ca33793?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc2MjgwMTI3MHww&ixlib=rb-4.1.0&q=85",
      type: "image"
    },
    {
      name: "Sandra Müller",
      role: "Business Coach",
      text: "Die Resell-Rechte sind unglaublich! Ich verkaufe die Templates weiter und generiere konstanten passiven Umsatz – komplett legal und ohne Einschränkungen. Beste Investition!",
      image: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxoZWFkc2hvdHxlbnwwfHx8fDE3NjI4MDEyNzZ8MA&ixlib=rb-4.1.0&q=85",
      type: "image"
    },
    {
      name: "Tom Richter",
      role: "Agentur-Inhaber",
      text: "Wir nutzen die Templates als Basis für Kundenprojekte. Schneller Turnaround, konstant hohe Qualität. Unser Team liebt die täglichen Updates!",
      image: "https://images.unsplash.com/photo-1762522927402-f390672558d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc2MjgwMTI3MHww&ixlib=rb-4.1.0&q=85",
      type: "image"
    },
    {
      name: "Lisa Bergmann",
      role: "Content Creatorin",
      text: "Endlich muss ich nicht mehr stundenlang nach Inspiration suchen. Die Templates sind modern, vielseitig und sparen mir pro Woche mindestens 6 Stunden Arbeit.",
      image: "https://images.unsplash.com/photo-1611432579699-484f7990b127?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxoZWFkc2hvdHxlbnwwfHx8fDE3NjI4MDEyNzZ8MA&ixlib=rb-4.1.0&q=85",
      type: "image"
    },
    {
      name: "FitZone Studio",
      role: "Fitnessstudio Kette",
      text: "Perfekt für unsere 5 Standorte. Jeder Manager kann die Templates schnell anpassen – einheitliches Branding garantiert. Unsere Social-Media-Präsenz ist explodiert!",
      image: "https://images.unsplash.com/photo-1573849653375-c01488ce30b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsYXB0b3AlMjB3b3Jrc3BhY2V8ZW58MHx8fGJsdWV8MTc2MjgwMTMxM3ww&ixlib=rb-4.1.0&q=85",
      type: "image"
    }
  ];

  const valueItems = [
    { icon: Calendar, title: "Tägliche neue Social Posts", description: "Professionelle Instagram, Facebook & LinkedIn Posts – fertig in Minuten" },
    { icon: Sparkles, title: "Reels & Shorts Cover", description: "Aufmerksamkeitsstarke Thumbnails für TikTok, Instagram & YouTube" },
    { icon: Target, title: "Story-Sequenzen", description: "Durchdachte Story-Abfolgen für maximale Engagement-Raten" },
    { icon: TrendingUp, title: "Ad-Varianten & A/B-Tests", description: "Performance-optimierte Werbeanzeigen in mehreren Varianten" },
    { icon: Layers, title: "Karussell-Slides", description: "Mehrseitige Posts für komplexe Botschaften & Storytelling" },
    { icon: Download, title: "Lead-Magnets & Workbooks", description: "Mindestens 2 verkaufsfähige Freebies pro Monat" },
    { icon: FileText, title: "Checklisten & Mini-Guides", description: "Praktische Tools für deine Community und Kunden" },
    { icon: Users, title: "Nischen-Fokus rotierend", description: "Handwerk, Coaches, lokale Dienstleister – immer relevante Inhalte" },
    { icon: Award, title: "Video-Tutorials & Q&A", description: "Schritt-für-Schritt-Anleitungen und Community-Support" }
  ];

  const painPointsTop = [
    { text: "Du hast keine Zeit für Content-Erstellung, aber deine Kunden erwarten regelmäßige Posts und Updates" },
    { text: "Ständige Ideenflaute und kreativer Stillstand bremsen dein Business-Wachstum massiv" },
    { text: "Zu wenig wiederkehrende Umsätze bedeuten keine finanzielle Planungssicherheit für die Zukunft" },
    { text: "Deine Kunden erwarten ständig frische, neue Designs, aber dein Budget ist streng begrenzt" },
    { text: "Deine Content-To-Do-Liste wächst schneller als du überhaupt abarbeiten kannst" },
    { text: "Jedes einzelne Projekt startet komplett bei Null – echte Skalierung ist unmöglich" }
  ];

  const painPointsBottom = [
    { text: "Du verlierst wertvolle Aufträge an günstigere Anbieter mit Standard-Templates und schnellerer Lieferung" },
    { text: "Stundenlange Recherche nach Design-Inspiration kostet dich Zeit, die du nicht hast" },
    { text: "Inkonsistentes Branding über verschiedene Social-Media-Kanäle schadet deiner Professionalität" },
    { text: "Schwankende Auftragslage und unvorhersehbare Cashflow-Probleme stressen dich jeden Monat aufs Neue" },
    { text: "Du bist gefangen im Hamsterrad: Mehr Arbeit bedeutet nicht automatisch mehr Einkommen" },
    { text: "Ohne skalierbare Produkte oder Services bleibt dein Einkommen immer an deine Arbeitszeit gebunden" }
  ];

  const solutionsTop = [
    { text: "In unter 10 Minuten verwandelst du ein Template in ein verkaufsfähiges Produkt – schneller geht's nicht" },
    { text: "Spare 2-5 Stunden pro Woche: Keine endlose Recherche mehr, kein Design von Grund auf" },
    { text: "Baue dir eine skalierbare Produktpalette auf, die wiederkehrende Umsätze ohne Mehrarbeit generiert" },
    { text: "Sei sofort lieferfähig und beeindrucke deine Kunden mit professionellem, schnellem Turnaround" },
    { text: "Täglich neue, frische Inhalte bedeuten: Nie wieder Ideenmangel oder kreative Blockaden" },
    { text: "Volle Resell-Rechte geben dir die Freiheit, Templates zu verkaufen wie DU willst – ohne Limits" }
  ];

  const solutionsBottom = [
    { text: "Garantiere professionelles, einheitliches Branding über alle deine Social-Media-Kanäle hinweg" },
    { text: "Steigere deine Auftragswerte und Gewinnmargen durch deutlich schnellere Delivery-Zeiten" },
    { text: "Beständige Premium-Qualität ohne Bad-Design-Days – deine Kunden lieben es" },
    { text: "Erreiche einen Premium-Look ganz ohne teures Designer-Budget oder Agentur-Kosten" },
    { text: "Skaliere dein Business endlich: Mehr Umsatz ohne proportional mehr Arbeitszeit investieren" },
    { text: "Baue passive Einkommensströme auf, indem du Templates als digitale Produkte weiterverkaufst" }
  ];

  const targetAudience = [
    "Social-Media-Freelancer:innen & Marketing-Profis",
    "Kleine und mittelständische Marketing-Agenturen",
    "Coaches, Berater:innen & Online-Trainer:innen",
    "Lokale Dienstleister (Friseure, Fitness, Gastronomie)",
    "Handwerksbetriebe jeder Art",
    "E-Commerce & Online-Shop-Betreiber:innen",
    "Content Creator & Influencer",
    "Virtuelle Assistenten für Social Media Management",
    "Komplette Einsteiger:innen OHNE jegliche Design-Vorkenntnisse"
  ];

  const resellFreedomTop = [
    { text: "Verkaufe Templates einzeln, als thematische Pakete oder umfangreiche Bundles – DU entscheidest die Strategie" },
    { text: "Setze komplett DEINE eigenen Preise – ob 5€, 50€ oder 500€ pro Template – null Vorgaben von uns" },
    { text: "Verkaufe an private Endkunden, Unternehmen, andere Freelancer oder Agenturen – völlig frei" },
    { text: "Nutze Templates unbegrenzt für deine Kundenprojekte (perfekt für Agenturen mit hohem Durchsatz!)" },
    { text: "Erstelle attraktive Produkt-Bundles und verkaufe sie auf Marktplätzen wie Etsy, Gumroad oder Digistore24" },
    { text: "Biete Template-Services als monatliches Abo-Modell an deine eigenen Kunden an und generiere planbare Umsätze" }
  ];

  const resellFreedomBottom = [
    { text: "KEINE Mengenbeschränkung: Verkaufe jedes Template 1x, 100x oder 1000x – so oft du willst" },
    { text: "Baue dir ein komplett passives Einkommen mit digitalen Produkten auf, die sich im Schlaf verkaufen" },
    { text: "Integriere Templates in deine bestehenden Service-Angebote und erhöhe sofort deinen Projekt-Wert" },
    { text: "Starte dein eigenes Template-Business von Null – ohne eigene Design-Skills oder teures Equipment" },
    { text: "Nutze Templates als Basis für Custom-Designs und reduziere deine Produktionszeit um bis zu 80%" },
    { text: "Biete White-Label-Services an: Passe Templates für Kunden an und verkaufe sie als deine eigene Arbeit" }
  ];

  // Gallery Section 1 - First 6 Templates (Early on page to create desire)
  const galleryItems = [
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/6czs1yua_11fe7805-2d68-4e34-beef-e75d0e81675a.webp",
      alt: "Social Media Template Design",
      caption: "Professionelles Social Media Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/fvxg7tmz_9eb97bcf-6d70-4d8a-9952-77f5e8d1eea5.webp",
      alt: "Instagram Story Template",
      caption: "Instagram Story Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/bh84tc06_14075710-321d-41e3-9bbd-0d5d97b8d833.webp",
      alt: "Business Post Template",
      caption: "Business Social Media Post"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/ohoaljvo_88ab4b20-f718-45b1-a3f2-179332b08461.webp",
      alt: "Marketing Template Design",
      caption: "Marketing Content Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/bkc525wg_e569c1c2-bb47-41e0-aa7f-6ef37427aad3.webp",
      alt: "Content Creator Template",
      caption: "Content Creator Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/v895x8fh_9fa41496-46ad-48d4-bd1b-df59a8492f8b.avif",
      alt: "Professional Template Pack",
      caption: "Apartment Rent Social Media Pack"
    }
  ];

  // Gallery Section 2 - Second 6 Templates (Later on page to reinforce desire before pricing)
  const galleryItems2 = [
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/38r7nlvv_93678547-ac3d-431b-a7c0-ec70c6bf8fcb.webp",
      alt: "2026 Calendar Template",
      caption: "Professioneller Jahreskalender 2026"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/azw76hla_4641cad9-1a1d-4d43-8e52-78f8d506b881.webp",
      alt: "Company Profile Template",
      caption: "Unternehmensprofil Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/nhvtt9o2_85723aec-40a6-49ba-af56-c998d690a7ba.webp",
      alt: "Hanukkah Photo Frame Template",
      caption: "Hanukkah Foto-Rahmen Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/77c6ivlr_11fe7805-2d68-4e34-beef-e75d0e81675a.webp",
      alt: "Financial Report PDF Template",
      caption: "Finanz-Report PDF Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/34rkostv_9eb97bcf-6d70-4d8a-9952-77f5e8d1eea5.webp",
      alt: "Christmas Cards Template",
      caption: "Weihnachtskarten Design"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_design-revamp-19/artifacts/g4muyjq0_a940c76d-c564-4f4a-9713-36e790371869.webp",
      alt: "Event Flyer Template",
      caption: "Event Flyer & Promotion Design"
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section id="hero" className="hero-section fade-in-section">
        <div className="hero-background-glow"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">Täglich neue Templates • Volle Resell-Freiheit</div>
            <h1 className="hero-title">
              Canva-Templates mit Resell-Rechten.
              <span className="hero-title-highlight"> Verkaufe frei weiter.</span>
            </h1>
            <p className="hero-subtitle">
              Schluss mit Ideenflaute und Zeitdruck. Erhalte jeden Tag professionelle, 
              verkaufsfähige Templates – sofort einsetzbar, komplett brandbar, FREI WEITERVERKAUFBAR. 
              Spare Zeit, steigere deinen Umsatz, skaliere dein Business ohne Limits.
            </p>
            <div className="hero-cta">
              <Button 
                size="lg" 
                className="btn-primary btn-glow" 
                data-cta="join-hero"
                onClick={() => setShowPayPalModal(true)}
              >
                Jetzt Mitglied werden – 59 €/Monat
                <ArrowRight className="btn-icon" size={20} />
              </Button>
              <p className="hero-microcopy">
                <CheckCircle size={16} /> Monatlich kündbar • <CheckCircle size={16} /> Sofortiger Zugang
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section id="trust" className="trust-section fade-in-section">
        <div className="container">
          <div className="trust-badge">
            <Star className="trust-star" size={16} />
            Vertraut von über 200+ Freelancern, Agenturen & Dienstleistern
            <Star className="trust-star" size={16} />
          </div>
          <div className="testimonials-grid-premium">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="testimonial-card-premium">
                <CardContent className="testimonial-content-premium">
                  <div className="testimonial-header">
                    <div className="testimonial-avatar-premium-image">
                      <img src={testimonial.image} alt={testimonial.name} className="avatar-img" />
                    </div>
                    <div className="testimonial-author-premium">
                      <p className="author-name-premium">{testimonial.name}</p>
                      <p className="author-role-premium">{testimonial.role}</p>
                    </div>
                  </div>
                  <p className="testimonial-text-premium">"{testimonial.text}"</p>
                  <div className="testimonial-rating">
                    {[1,2,3,4,5].map(i => <Star key={i} size={14} fill="#FFB84D" stroke="#FFB84D" />)}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section 1 - MOVED HERE for early desire creation */}
      <section id="gallery" className="gallery-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Template-Beispiele Teil 1</div>
            <h2 className="section-title">Entdecke unsere professionellen Template-Designs</h2>
            <p className="section-subtitle">
              Jedes Template ist sofort einsatzbereit, vollständig anpassbar und verkaufsfertig. 
              Hier ist die erste Auswahl aus unserem täglich wachsenden Portfolio mit über 1.000+ Designs:
            </p>
          </div>
          <div className="gallery-grid-premium">
            {galleryItems.map((item, index) => (
              <div key={index} className="gallery-item-premium">
                <div className="gallery-image-wrapper-premium">
                  <img src={item.src} alt={item.alt} className="gallery-image" />
                  <div className="gallery-overlay">
                    <p className="gallery-caption-overlay">{item.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="gallery-note">
            <RefreshCw size={16} /> Templates werden täglich erweitert und regelmäßig mit neuen Designs aktualisiert
          </p>
          <div className="section-cta">
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-gallery"
              onClick={() => setShowPayPalModal(true)}
            >
              Zugang zu allen Templates sichern
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* Pain Points Section 1 */}
      <section id="pain-1" className="pain-section-clean fade-in-section">
        <div className="container">
          <div className="pain-content-clean">
            <div className="pain-text-clean">
              <div className="section-label">Das Problem</div>
              <h2 className="section-title-clean">Kennst du diese 6 Haupt-Herausforderungen?</h2>
              <p className="section-intro-clean">
                Als Freelancer, Agentur oder Selbstständige:r bist du täglich mit diesen frustrierenden 
                Situationen konfrontiert, die dein Wachstum bremsen und deine Energie rauben:
              </p>
              <div className="clean-checklist">
                {painPointsTop.map((point, index) => (
                  <div key={index} className="checklist-item checklist-problem">
                    <CheckCircle size={22} className="check-icon check-problem" />
                    <span>{point.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="pain-image-clean">
              <img src="https://images.unsplash.com/photo-1586473219010-2ffc57b0d282?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHx3b3JrJTIwc3RyZXNzfGVufDB8fHx8MTc2Mjc0MTgzMnww&ixlib=rb-4.1.0&q=85" alt="Überforderung" className="section-image-clean" />
            </div>
          </div>
        </div>
      </section>

      {/* Pain Points Section 2 */}
      <section id="pain-2" className="pain-section-dark fade-in-section">
        <div className="container">
          <div className="pain-dark-content">
            <h3 className="pain-dark-title">Und das ist noch nicht alles – weitere 6 Probleme belasten dich:</h3>
            <div className="clean-checklist clean-checklist-dark">
              {painPointsBottom.map((point, index) => (
                <div key={index} className="checklist-item checklist-dark">
                  <X size={22} className="check-icon check-dark" />
                  <span>{point.text}</span>
                </div>
              ))}
            </div>
            <div className="pain-conclusion-box">
              <strong>Das verheerende Ergebnis?</strong> Permanenter Stress, verlorene Aufträge, stagnierendes oder sogar sinkendes Einkommen und absolut keine Zeit für echtes Business-Wachstum. <strong>Aber es gibt einen Ausweg...</strong>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section 1 */}
      <section id="solution-1" className="solution-section-clean fade-in-section">
        <div className="container">
          <div className="solution-content-clean">
            <div className="solution-image-clean">
              <img src="https://images.unsplash.com/photo-1628763448616-5d81ad40b1fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxmcmVlbGFuY2VyJTIwbGFwdG9wfGVufDB8fHx8MTc2Mjc0MTgxOHww&ixlib=rb-4.1.0&q=85" alt="Erfolg" className="section-image-clean" />
            </div>
            <div className="solution-text-clean">
              <div className="section-label solution-label">Die Lösung</div>
              <h2 className="section-title-clean">Pixel56 Template Club: Dein ultimativer Game-Changer</h2>
              <p className="section-intro-clean">
                Stell dir vor, du hättest täglich Zugang zu frischen, professionellen Templates, die bereits 
                fix und fertig zum Verkaufen oder Nutzen sind. Genau das bekommst du hier – und noch viel mehr:
              </p>
              <div className="clean-checklist">
                {solutionsTop.map((solution, index) => (
                  <div key={index} className="checklist-item checklist-solution">
                    <CheckCircle size={22} className="check-icon check-solution" />
                    <span>{solution.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section 2 */}
      <section id="solution-2" className="solution-section-extra fade-in-section">
        <div className="container">
          <h3 className="extra-benefits-title">Noch mehr unschlagbare Vorteile, die dein Business transformieren:</h3>
          <div className="clean-checklist clean-checklist-centered">
            {solutionsBottom.map((solution, index) => (
              <div key={index} className="checklist-item checklist-benefit">
                <CheckCircle size={22} className="check-icon check-benefit" />
                <span>{solution.text}</span>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-solution"
              onClick={() => setShowPayPalModal(true)}
            >
              Ja, diese Vorteile will ich nutzen!
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* Value Stack Section */}
      <section id="value" className="value-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Was du bekommst</div>
            <h2 className="section-title">Jeden Tag neue, sofort verkaufsfähige Designs</h2>
            <p className="section-subtitle">
              Mit dem Pixel56 Template Club erhältst du alles, was du brauchst, um deine Social-Media-Präsenz 
              zu dominieren UND gleichzeitig dein Portfolio profitabel zu monetarisieren:
            </p>
          </div>
          <div className="value-grid-clean">
            {valueItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <Card key={index} className="value-card-clean">
                  <CardContent className="value-card-content-clean">
                    <div className="value-icon-clean">
                      <Icon size={32} />
                    </div>
                    <h3 className="value-title-clean">{item.title}</h3>
                    <p className="value-description-clean">{item.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
          <div className="section-cta">
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-value"
              onClick={() => setShowPayPalModal(true)}
            >
              Sichere dir tägliche Templates jetzt!
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* Business Models Section - NEW */}
      <section id="business-models" className="business-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Verd
ienst-Möglichkeiten</div>
            <h2 className="section-title">3 profitable Wege, wie du mit Pixel56 Geld verdienst</h2>
            <p className="section-subtitle">
              Nutze die Templates nicht nur für dich selbst, sondern baue dir damit ein komplettes Business auf. 
              Hier sind drei bewährte Modelle, mit denen unsere Mitglieder bereits erfolgreich Geld verdienen:
            </p>
          </div>
          <div className="business-models-grid">
            <Card className="business-model-card">
              <CardContent className="business-model-content">
                <div className="business-model-number">1</div>
                <h3 className="business-model-title">Template-Reseller</h3>
                <p className="business-model-description">
                  Passe Templates an deine Zielgruppe an und verkaufe sie als fertige Produkte auf Marktplätzen 
                  wie Etsy, Gumroad oder deinem eigenen Online-Shop. Setze deine eigenen Preise (oft 15-50€ pro Template) 
                  und verkaufe unbegrenzt oft. Mit nur 10 Verkäufen pro Monat deckst du bereits deine Mitgliedschaft 
                  und machst Gewinn!
                </p>
              </CardContent>
            </Card>
            <Card className="business-model-card">
              <CardContent className="business-model-content">
                <div className="business-model-number">2</div>
                <h3 className="business-model-title">Social Media Service-Anbieter</h3>
                <p className="business-model-description">
                  Nutze die Templates, um für lokale Unternehmen, Handwerksbetriebe oder Coaches professionellen 
                  Content zu erstellen. Biete monatliche Pakete an (z.B. 10 Posts für 200-500€/Monat). Du passt 
                  einfach die Templates an, fügst Logos und Texte ein – fertig! Spare 80% Zeit gegenüber komplettem 
                  Custom-Design und bediene mehr Kunden gleichzeitig.
                </p>
              </CardContent>
            </Card>
            <Card className="business-model-card">
              <CardContent className="business-model-content">
                <div className="business-model-number">3</div>
                <h3 className="business-model-title">Abo-Modell für Template-Zugang</h3>
                <p className="business-model-description">
                  Erstelle dein eigenes Template-Abo: Biete Kunden monatlichen Zugang zu einer bestimmten Anzahl 
                  angepasster Templates (z.B. 5 Templates/Monat für 49€). Du nutzt Pixel56 Templates als Basis, 
                  brandest sie professionell und lieferst sie an deine Abo-Kunden. Planbare, wiederkehrende Umsätze 
                  ohne ständige Akquise!
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section id="target-audience" className="target-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Für wen?</div>
            <h2 className="section-title">Perfekt für diese 9 Branchen & Berufsgruppen</h2>
            <p className="section-subtitle">
              Egal ob du bereits im Business bist oder komplett neu startest: Pixel56 Templates funktionieren 
              für JEDEN, der Zeit sparen und gleichzeitig Geld verdienen möchte. Keine Design-Kenntnisse erforderlich!
            </p>
          </div>
          <div className="target-grid-clean">
            {targetAudience.map((target, index) => (
              <div key={index} className="target-item-clean">
                <CheckCircle size={24} className="target-icon-clean" />
                <span>{target}</span>
              </div>
            ))}
          </div>
          <div className="target-highlight-box">
            <Heart size={24} className="highlight-icon" />
            <p>
              <strong>Besonders wichtig:</strong> Du brauchst KEINERLEI Design-Kenntnisse oder technisches Wissen! 
              Auch komplette Einsteiger:innen können sofort loslegen und binnen Minuten professionelle Ergebnisse erzielen. 
              Die Templates sind bereits fertig designed – du änderst einfach Farben, Texte und fügst dein Logo ein. 
              Das war's schon!
            </p>
          </div>
          <div className="section-cta">
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-target"
              onClick={() => setShowPayPalModal(true)}
            >
              Das passt perfekt zu mir – Jetzt starten!
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how" className="how-section-modern fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">So einfach geht's</div>
            <h2 className="section-title">In nur 3 simplen Schritten zu deinen ersten Umsätzen</h2>
            <p className="section-subtitle">
              Keine komplizierten Prozesse. Kein technisches Vorwissen nötig. Kein stundenlanges Einarbeiten. 
              Du kannst buchstäblich heute noch starten und erste Ergebnisse sehen:
            </p>
          </div>
          <div className="steps-modern-container">
            <div className="step-modern">
              <div className="step-visual">
                <div className="step-number-modern">1</div>
                <div className="step-connector"></div>
              </div>
              <div className="step-content-modern">
                <h3 className="step-title-modern">Mitglied werden</h3>
                <p className="step-description-modern">
                  Tritt dem Pixel56 Template Club mit einem Klick bei und erhalte <strong>sofortigen, unmittelbaren Zugang</strong> zu 
                  allen aktuellen Templates sowie dem kompletten Archiv. Keine Wartezeit, keine Freischaltung – 
                  du kannst direkt nach der Anmeldung loslegen!
                </p>
              </div>
            </div>
            <div className="step-modern">
              <div className="step-visual">
                <div className="step-number-modern">2</div>
                <div className="step-connector"></div>
              </div>
              <div className="step-content-modern">
                <h3 className="step-title-modern">Template öffnen & anpassen</h3>
                <p className="step-description-modern">
                  Wähle ein Template aus, klicke auf den Link und es öffnet sich direkt in Canva. Jetzt passt du 
                  einfach <strong>Logo, Farben, Schriften und Texte</strong> in wenigen Minuten an deine Marke oder 
                  deinen Kunden an. Kinderleicht mit Drag & Drop – fertig!
                </p>
              </div>
            </div>
            <div className="step-modern">
              <div className="step-visual">
                <div className="step-number-modern">3</div>
              </div>
              <div className="step-content-modern">
                <h3 className="step-title-modern">Verkaufen oder nutzen – völlig frei!</h3>
                <p className="step-description-modern">
                  Jetzt hast du die volle Freiheit: Verkaufe die Templates <strong>unbegrenzt weiter</strong> – an wen du willst, 
                  so oft du willst, zu DEINEN Preisen. Oder nutze sie für deine eigenen Social-Media-Kanäle und 
                  Kundenprojekte. Die Möglichkeiten sind endlos!
                </p>
              </div>
            </div>
          </div>
          <div className="how-info-box">
            <Lightbulb size={20} />
            <p>Mit Canva Free vollständig nutzbar • Einige Canva Pro-Elemente können ggf. ersetzt werden für optimale Kompatibilität</p>
          </div>
        </div>
      </section>

      {/* Detailed Process Section - NEW */}
      <section id="detailed-process" className="detailed-process-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Der komplette Ablauf</div>
            <h2 className="section-title">Von der Anmeldung bis zum ersten Verkauf – So läuft's ab</h2>
            <p className="section-subtitle">
              Hier erfährst du Schritt für Schritt, wie du vom Mitglied zum erfolgreichen Template-Verkäufer wirst. 
              Kein Fachchinesisch, keine versteckten Haken – nur der klare, ehrliche Ablauf.
            </p>
          </div>

          <div className="detailed-process-grid">
            {/* Step 1 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 1</div>
                <h3 className="process-detail-title">📝 Anmelden & Bezahlen</h3>
                <p className="process-detail-text">
                  Klicke auf einen der "Jetzt Mitglied werden"-Buttons und du landest auf unserer Skool-Community-Seite. 
                  Dort registrierst du dich mit deiner E-Mail und wählst die monatliche Zahlung (59€/Monat). 
                  Bezahlung erfolgt sicher über Stripe oder PayPal. Nach erfolgreicher Zahlung bist du sofort Mitglied.
                </p>
              </CardContent>
            </Card>

            {/* Step 2 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 2</div>
                <h3 className="process-detail-title">🚪 Community betreten</h3>
                <p className="process-detail-text">
                  Nach der Anmeldung erhältst du automatisch Zugang zur geschlossenen Pixel56 Community auf Skool. 
                  Dort findest du alle Templates, Anleitungen, Video-Tutorials und kannst dich mit anderen Mitgliedern austauschen. 
                  Die Community ist dein Hauptzugang zu allem.
                </p>
              </CardContent>
            </Card>

            {/* Step 3 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 3</div>
                <h3 className="process-detail-title">📅 Täglich 5-10 Templates sichern</h3>
                <p className="process-detail-text">
                  Jeden Tag werden in der Community <strong>5-10 neue Canva-Template-Links</strong> gepostet. 
                  Diese Links führen direkt zu professionell gestalteten Canva-Designs. Du findest sie übersichtlich 
                  kategorisiert nach Branchen (Handwerk, Coaches, E-Commerce, etc.) und Verwendungszweck 
                  (Social Posts, Stories, Lead-Magnets, etc.).
                </p>
              </CardContent>
            </Card>

            {/* Step 4 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 4</div>
                <h3 className="process-detail-title">🎨 Design kopieren & zu deinem eigenen machen</h3>
                <p className="process-detail-text">
                  Klicke auf einen Canva-Link → Das Design öffnet sich in Canva → Klicke auf "Als Kopie verwenden" oder 
                  "Duplizieren" → <strong>Jetzt gehört das Design DIR!</strong> Du kannst es beliebig anpassen: 
                  Logo, Farben, Schriften, Texte ändern. Das Design ist jetzt in deinem Canva-Account gespeichert.
                </p>
              </CardContent>
            </Card>

            {/* Step 5 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 5</div>
                <h3 className="process-detail-title">💼 Nutzen: Content für Kunden oder dich selbst</h3>
                <p className="process-detail-text">
                  <strong>Option A:</strong> Erstelle mit den Templates professionellen Content für deine eigenen Social-Media-Kanäle 
                  oder Business.<br />
                  <strong>Option B:</strong> Biete deinen Kunden (Coaches, lokale Unternehmen, etc.) Social-Media-Services an. 
                  Du passt die Templates an ihre Marke an und lieferst fertige Posts in Rekordzeit.
                </p>
              </CardContent>
            </Card>

            {/* Step 6 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 6</div>
                <h3 className="process-detail-title">💰 Weiterverkaufen auf Marktplätzen</h3>
                <p className="process-detail-text">
                  Du kannst die Templates als fertige Produkte weiterverkaufen auf Plattformen wie <strong>Etsy, 
                  Amazon KDP, Gumroad, Digistore24</strong> oder deinem eigenen Online-Shop. 
                  Setze deine eigenen Preise (z.B. 15-50€ pro Template) und verkaufe unbegrenzt oft. 
                  Das ist passives Einkommen!
                </p>
              </CardContent>
            </Card>

            {/* Step 7 */}
            <Card className="process-detail-card">
              <CardContent className="process-detail-content">
                <div className="process-step-badge">Schritt 7</div>
                <h3 className="process-detail-title">📱 Social Media Service anbieten</h3>
                <p className="process-detail-text">
                  Mit deinem ständig wachsenden Template-Arsenal kannst du professionelle Social-Media-Services anbieten. 
                  Beispiel: Monatliche Pakete für Unternehmen, Coaches oder Creator (z.B. 10 Posts/Monat für 200-500€). 
                  Du sparst 80% Zeit durch die Templates und kannst mehr Kunden gleichzeitig bedienen.
                </p>
              </CardContent>
            </Card>

            {/* Step 8 - IMPORTANT */}
            <Card className="process-detail-card process-detail-important">
              <CardContent className="process-detail-content">
                <div className="process-step-badge process-badge-warning">⚠️ Wichtig</div>
                <h3 className="process-detail-title">🔒 Was passiert nach der Kündigung?</h3>
                <p className="process-detail-text">
                  <strong>Klare Ansage:</strong> Sobald deine Mitgliedschaft endet (durch Kündigung oder Zahlungsausfall), 
                  <strong>verlierst du die Rechte, die Templates weiter zu verkaufen</strong>. Designs, die du bereits 
                  erstellt hast, bleiben in deinem Canva-Account, aber du darfst sie nicht mehr kommerziell nutzen oder 
                  verkaufen. Für bereits verkaufte Produkte gibt es keine Rückforderung – die bleiben bei dir. 
                  Diese Regelung ist fair und schützt beide Seiten.
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="process-cta-box">
            <h3>Alles klar? Bereit durchzustarten?</h3>
            <p>
              Du weißt jetzt genau, wie der Ablauf funktioniert. Keine versteckten Überraschungen, keine unklaren Regelungen. 
              Tritt jetzt bei und sichere dir heute noch deine ersten Templates!
            </p>
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-detailed-process"
              onClick={() => setShowPayPalModal(true)}
            >
              Ja, ich bin bereit – Jetzt Mitglied werden!
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* Detailed Membership Process Section - NEW */}
      <section id="membership-process" className="membership-process-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">So funktioniert deine Mitgliedschaft</div>
            <h2 className="section-title">Dein Weg zum erfolgreichen Template-Business – Transparent & Verständlich erklärt</h2>
            <p className="section-subtitle">
              Keine versteckten Klauseln, keine komplizierten Prozesse. Hier erfährst du genau, 
              was nach deiner Anmeldung passiert und wie du sofort starten kannst.
            </p>
          </div>

          <div className="membership-process-content">
            <Card className="process-info-card">
              <CardContent className="process-info-content">
                <div className="process-info-header">
                  <div className="process-info-icon">💳</div>
                  <h3>1. Bezahlung & Zugang zur Akademie</h3>
                </div>
                <p>
                  Nach deiner Zahlung von <strong>59€/Monat über PayPal</strong> erhältst du sofortigen Zugang zur 
                  exklusiven <a href="https://www.skool.com/digitale-produkt-akademie-6761" target="_blank" rel="noopener noreferrer" className="process-link">
                  Digitale Produkt Akademie auf Skool</a>. Dort findest du:
                </p>
                <ul className="process-list">
                  <li>✅ Alle aktuellen und vergangenen Templates zum Download</li>
                  <li>✅ Übersichtliche Kategorien nach Branchen sortiert</li>
                  <li>✅ Video-Tutorials zur Template-Anpassung</li>
                  <li>✅ Community-Forum zum Austausch mit anderen Mitgliedern</li>
                  <li>✅ Support bei Fragen zur Nutzung</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="process-info-card">
              <CardContent className="process-info-content">
                <div className="process-info-header">
                  <div className="process-info-icon">📅</div>
                  <h3>2. Täglich neue Templates zum Download</h3>
                </div>
                <p>
                  Jeden Tag werden in der Akademie <strong>neue verkaufsfertige Canva-Templates</strong> hochgeladen. 
                  Diese kannst du:
                </p>
                <ul className="process-list">
                  <li>🎨 <strong>Herunterladen</strong> – Alle Templates als Canva-Links verfügbar</li>
                  <li>✏️ <strong>Bearbeiten</strong> – Passe Farben, Texte, Logos beliebig an</li>
                  <li>💰 <strong>Weiterverkaufen</strong> – Verkaufe sie als deine eigenen Produkte</li>
                  <li>🚀 <strong>Für Kunden nutzen</strong> – Erstelle Content für deine Kunden in Minuten</li>
                  <li>📱 <strong>Für dich selbst nutzen</strong> – Professioneller Content für dein eigenes Marketing</li>
                </ul>
                <div className="process-highlight">
                  <strong>Wichtig:</strong> Die Templates sind im Canva-Format. Du klickst auf den Link, 
                  duplizierst das Design in deinem Canva-Account und kannst es sofort anpassen.
                </div>
              </CardContent>
            </Card>

            <Card className="process-info-card">
              <CardContent className="process-info-content">
                <div className="process-info-header">
                  <div className="process-info-icon">📜</div>
                  <h3>3. Kündigungsfrist & Vertragslaufzeit</h3>
                </div>
                <p>
                  <strong>Keine langfristigen Verpflichtungen – Volle Flexibilität für dich!</strong>
                </p>
                <ul className="process-list">
                  <li>⏱️ <strong>Monatlich kündbar</strong> – Keine Mindestlaufzeit, keine Kündigungsfrist</li>
                  <li>🔄 <strong>Jederzeit beenden</strong> – Du kannst zum Monatsende kündigen</li>
                  <li>💡 <strong>Kein Risiko</strong> – Teste die Templates einen Monat und entscheide dann</li>
                </ul>
                <div className="process-highlight">
                  Du zahlst nur so lange, wie du die Templates aktiv nutzen möchtest. 
                  Keine versteckten Gebühren, keine Überraschungen.
                </div>
              </CardContent>
            </Card>

            <Card className="process-info-card process-info-warning">
              <CardContent className="process-info-content">
                <div className="process-info-header">
                  <div className="process-info-icon">⚠️</div>
                  <h3>4. Was passiert nach der Kündigung?</h3>
                </div>
                <p>
                  <strong>Wichtige Information zu deinen Nutzungsrechten:</strong>
                </p>
                <ul className="process-list">
                  <li>🔒 <strong>Weiterverkaufs-Rechte enden</strong> – Nach Kündigung darfst du die Templates nicht mehr kommerziell verkaufen</li>
                  <li>✅ <strong>Private Nutzung erlaubt</strong> – Du kannst heruntergeladene Templates weiterhin für dich selbst nutzen</li>
                  <li>💰 <strong>Bereits verkaufte Produkte</strong> – Bleiben bei dir, keine Rückforderung</li>
                  <li>📁 <strong>Zugang zur Akademie endet</strong> – Keine neuen Templates mehr nach Kündigungsende</li>
                </ul>
                <div className="process-highlight process-highlight-warning">
                  <strong>Klare Regelung:</strong> Solange du Mitglied bist, hast du volle Resell-Rechte. 
                  Nach der Kündigung erlischt das kommerzielle Nutzungsrecht für Weiterverkauf. 
                  Bereits verkaufte Produkte sind davon nicht betroffen.
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="membership-cta-box">
            <h3>Bereit, dein Template-Business zu starten?</h3>
            <p>
              Jetzt weißt du genau, wie alles funktioniert. Keine offenen Fragen mehr. 
              Starte noch heute und sichere dir Zugang zu täglich neuen Templates!
            </p>
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-membership-process"
              onClick={() => setShowPayPalModal(true)}
            >
              Ja, jetzt Mitglied werden & durchstarten!
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* Gallery Section 2 - Strategically placed before pricing to reinforce desire */}
      <section id="gallery-2" className="gallery-section gallery-section-alt fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Template-Beispiele Teil 2</div>
            <h2 className="section-title">Von Kalendern bis Lead-Magnets – Unbegrenzte Möglichkeiten</h2>
            <p className="section-subtitle">
              Kalender, Company Profiles, Event-Designs, Finanz-Reports und saisonale Vorlagen – 
              Diese Template-Vielfalt ermöglicht dir, in jeder Nische verkaufsfertige Produkte anzubieten:
            </p>
          </div>
          <div className="gallery-grid-premium">
            {galleryItems2.map((item, index) => (
              <div key={index} className="gallery-item-premium">
                <div className="gallery-image-wrapper-premium">
                  <img src={item.src} alt={item.alt} className="gallery-image" />
                  <div className="gallery-overlay">
                    <p className="gallery-caption-overlay">{item.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="gallery-note">
            <Sparkles size={16} /> Diese Templates sind nur ein kleiner Einblick – täglich kommen neue Designs hinzu
          </p>
          <div className="section-cta">
            <Button 
              size="lg" 
              className="btn-primary btn-glow"
              data-cta="join-gallery-2"
              onClick={() => setShowPayPalModal(true)}
            >
              Jetzt Mitglied werden & alle Templates nutzen
              <ArrowRight className="btn-icon" size={20} />
            </Button>
          </div>
        </div>
      </section>

      {/* Resell Freedom Section 1 */}
      <section id="resell-1" className="freedom-section-clean fade-in-section">
        <div className="container">
          <div className="freedom-content-clean">
            <div className="freedom-text-clean">
              <div className="section-label freedom-label">Volle Freiheit</div>
              <h2 className="section-title-clean">Verkaufe Templates genau so, wie DU es willst – komplett ohne Limits!</h2>
              <p className="freedom-intro-clean">
                Anders als bei den meisten anderen Template-Anbietern gibt es bei Pixel56 <strong>KEINE einschränkenden Regeln</strong>. 
                Mit deiner Mitgliedschaft erhältst du volle kommerzielle Resell-Rechte und kannst die Templates nutzen, 
                wie es für DEIN Business am besten funktioniert:
              </p>
              <div className="clean-checklist">
                {resellFreedomTop.map((item, index) => (
                  <div key={index} className="checklist-item checklist-freedom">
                    <CheckCircle size={22} className="check-icon check-freedom" />
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="freedom-image-clean">
              <img src="https://images.unsplash.com/photo-1688561807971-728cd39eb71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwYnVzaW5lc3MlMjBsYXB0b3B8ZW58MHx8fHwxNzYyNzQ0NTY3fDA&ixlib=rb-4.1.0&q=85" alt="Digitales Business" className="section-image-clean" />
            </div>
          </div>
        </div>
      </section>

      {/* Resell Freedom Section 2 */}
      <section id="resell-2" className="freedom-section-extra fade-in-section">
        <div className="container">
          <h3 className="extra-freedom-title">Noch mehr Möglichkeiten für maximale Profitabilität:</h3>
          <div className="clean-checklist clean-checklist-centered">
            {resellFreedomBottom.map((item, index) => (
              <div key={index} className="checklist-item checklist-freedom-extra">
                <Rocket size={22} className="check-icon check-freedom-extra" />
                <span>{item.text}</span>
              </div>
            ))}
          </div>
          <div className="freedom-conclusion-box">
            <Shield size={28} className="conclusion-icon" />
            <div>
              <strong>Die einzige Einschränkung:</strong> Du darfst die Resell-Rechte selbst NICHT an andere weitergeben 
              oder weiterverkaufen (kein PLR/MRR-Modell). Aber die Templates selbst? <strong>Verkaufe sie komplett frei, 
              unbegrenzt oft und zu deinen eigenen Konditionen!</strong> Das ist echte unternehmerische Freiheit.
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing-section fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Investition</div>
            <h2 className="section-title">Alles inklusive. Ein fairer, transparenter Preis.</h2>
          </div>
          <Card className="pricing-card-premium">
            <CardContent className="pricing-content-premium">
              <div className="pricing-badge-top">BELIEBTESTE WAHL</div>
              <div className="pricing-header-premium">
                <h3 className="pricing-plan-name-premium">Pixel56 Template Club</h3>
                <div className="pricing-amount-premium">
                  <span className="pricing-currency-premium">€</span>
                  <span className="pricing-price-premium">59</span>
                  <span className="pricing-period-premium">/Monat</span>
                </div>
                <p className="pricing-tagline">Komplettpaket ohne versteckte Kosten oder Zusatzgebühren</p>
              </div>
              <ul className="pricing-features-premium">
                <li><CheckCircle size={22} /> <strong>Täglich neue Templates</strong> (mindestens 20-30 pro Monat garantiert)</li>
                <li><CheckCircle size={22} /> <strong>Volle Resell-Rechte</strong> – verkaufe frei weiter, unbegrenzt, ohne Limits</li>
                <li><CheckCircle size={22} /> Kommerzielle Nutzung ohne jegliche Einschränkungen oder Auflagen</li>
                <li><CheckCircle size={22} /> Sofortiger Portfolio-Boost durch professionelle, einsatzbereite Premium-Designs</li>
                <li><CheckCircle size={22} /> <strong>Monatlich kündbar</strong> – keine langfristigen Verträge oder Bindungen</li>
                <li><CheckCircle size={22} /> Vollständiger Zugriff auf das <strong>komplette Template-Archiv</strong> mit Hunderten Designs</li>
                <li><CheckCircle size={22} /> Aktive Community mit Support, Q&A-Sessions & hilfreichen Video-Tutorials</li>
                <li><CheckCircle size={22} /> Regelmäßige Updates mit neuen Template-Kategorien und Design-Trends</li>
                <li><CheckCircle size={22} /> <strong>Lebenslange Nutzungsrechte</strong> für alle während Mitgliedschaft erhaltenen Templates</li>
              </ul>
              <div className="pricing-notice-premium">
                <p>
                  <strong>Wichtiger Hinweis:</strong> Dies ist ein digitales Produkt mit sofortiger Bereitstellung. 
                  Mit Freischaltung des Zugangs erlischt das gesetzliche Widerrufsrecht. 
                  Alle anderen gesetzlichen Rechte bleiben selbstverständlich unberührt.
                </p>
              </div>
              <Button 
                size="lg" 
                className="btn-primary btn-pricing btn-glow"
                data-cta="join-pricing"
                onClick={() => setShowPayPalModal(true)}
              >
                Jetzt Mitglied werden – 59 €/Monat
                <ArrowRight className="btn-icon" size={20} />
              </Button>
              <p className="pricing-guarantee">
                <Shield size={16} /> Sichere Zahlung • Sofortiger Zugang • Jederzeit monatlich kündbar
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="faq-section-premium fade-in-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Häufige Fragen</div>
            <h2 className="section-title">Alle wichtigen Fragen transparent beantwortet</h2>
            <p className="section-subtitle">
              Hier findest du ehrliche, klare Antworten auf die häufigsten Fragen zu Pixel56. 
              Sollte deine Frage nicht dabei sein, kontaktiere uns jederzeit!
            </p>
          </div>
          <Accordion type="single" collapsible className="faq-accordion-premium">
            <AccordionItem value="item-1" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Was genau darf ich mit den Templates machen?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                Du darfst die Templates bearbeiten, mit deinem Branding versehen und <strong>komplett frei weiterverkaufen – 
                an wen du willst, so oft du willst, zu DEINEN selbst festgelegten Preisen</strong>. Nutze sie für Kundenprojekte, 
                verkaufe sie einzeln, als Pakete, auf Marktplätzen oder in deinem eigenen Shop. <strong>Die einzige Regel:</strong> 
                Du darfst die Resell-Rechte selbst NICHT weitergeben oder weiterverkaufen (kein PLR/MRR-Modell). Aber die Templates? 
                Absolut frei nutzbar!
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Brauche ich Canva Pro oder reicht die kostenlose Version?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                Die allermeisten Templates funktionieren einwandfrei auch mit Canva Free. Einige wenige Templates können 
                vereinzelt Canva-Pro-Elemente enthalten (z.B. bestimmte Schriften oder Stock-Fotos), die du dann ggf. durch 
                kostenlose Alternativen ersetzen kannst. Für maximale Flexibilität und den vollen Funktionsumfang empfehlen 
                wir Canva Pro, aber es ist keine zwingende Voraussetzung.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Wie oft erhalte ich neue Template-Inhalte?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                Wir streben <strong>tägliche Updates</strong> an und liefern garantiert mindestens 20-30 brandneue Templates 
                pro Monat. Die Nischen und Branchen rotieren kontinuierlich (Handwerk, Coaching, lokale Dienstleister, E-Commerce, etc.), 
                sodass du permanent frischen, vielseitigen Content für unterschiedlichste Zielgruppen erhältst und ein breites 
                Portfolio aufbauen kannst.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-4" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Kann ich Templates wirklich unbegrenzt oft weiterverkaufen?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                <strong>Ja, absolut und ohne jede Einschränkung!</strong> Es gibt keine Mengenbeschränkung whatsoever. 
                Verkaufe jedes Template 1x, 100x, 1000x oder noch öfter – so viel und so oft du möchtest. Setze deine 
                eigenen Preise (5€, 50€, 500€ – was immer sinnvoll ist). Das ist echte, skalierbare Business-Freiheit für dein 
                Unternehmen. Die einzige Beschränkung: Du darfst die Resell-Lizenz selbst nicht weitergeben.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-5" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Kann ich die Mitgliedschaft jederzeit kündigen?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                Ja, die Mitgliedschaft ist <strong>jederzeit monatlich kündbar</strong> – ohne Wenn und Aber, ohne Tricks. 
                Kündige einfach bequem über deinen Mitgliederbereich oder per E-Mail an info@pixel56.de zum Ende des laufenden 
                Abrechnungsmonats. Alle Templates, die du während deiner aktiven Mitgliedschaft erhalten hast, darfst du 
                <strong>zeitlich unbefristet weiternutzen und verkaufen</strong> – auch nach der Kündigung!
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-6" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Welche Branchen und Nischen werden konkret abgedeckt?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                Die Templates rotieren systematisch durch zahlreiche profitable Branchen: Handwerk (Dachdecker, Maler, 
                Elektriker, Installateure), lokale Dienstleister (Friseure, Beautysalons, Fitnessstudios, Restaurants, Cafés), 
                Coaches & Berater, Online-Business & E-Learning, E-Commerce & Produktverkäufer, Immobilienmakler, Fitness- 
                und Ernährungstrainer, und viele mehr. So baust du dir ein <strong>extrem vielseitiges, verkaufsstarkes 
                Portfolio</strong> auf.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-7" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Wie genau funktioniert die Template-Lieferung?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                Nach deiner Anmeldung erhältst du <strong>sofortigen, unmittelbaren Zugang</strong> zu unserem exklusiven 
                Mitgliederbereich (gehostet auf Skool oder ähnlicher Plattform), wo täglich neue Template-Links veröffentlicht 
                werden. Klicke einfach auf einen beliebigen Link, das Template öffnet sich automatisch in Canva, und du kannst 
                es sofort duplizieren und nach Belieben anpassen. Kein mühsamer Download, keine Installation, keine technischen 
                Hürden – direkt durchstarten!
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-8" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Brauche ich Design-Kenntnisse oder technisches Vorwissen?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                <strong>Absolut nicht!</strong> Pixel56 ist bewusst auch für <strong>komplette Einsteiger ohne jegliche 
                Design-Erfahrung</strong> konzipiert. Die Templates sind bereits vollständig professionell gestaltet – 
                du änderst lediglich Farben, fügst Texte ein und ersetzt Logos. Canva funktioniert kinderleicht mit 
                intuitiver Drag-&-Drop-Bedienung. Zudem stehen dir Video-Tutorials, How-to-Guides und Community-Support 
                jederzeit zur Verfügung.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-9" className="faq-item-premium">
              <AccordionTrigger className="faq-trigger-premium">Kann ich Templates für meine Agentur-Kundenprojekte nutzen?</AccordionTrigger>
              <AccordionContent className="faq-content-premium">
                <strong>Ja, selbstverständlich und absolut unbegrenzt!</strong> Du kannst die Templates <strong>so oft du willst 
                für sämtliche Kundenprojekte</strong> verwenden. Das ist besonders perfekt für Agenturen oder Freelancer mit 
                hohem Projekt-Durchsatz. Spare massiv Zeit, steigere deine Gewinnmarge durch schnellere Lieferzeiten und 
                beeindrucke Kunden konstant mit professionellen, hochwertigen Ergebnissen.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </section>

      {/* PayPal Modal */}
      {showPayPalModal && (
        <div className="modal-overlay" onClick={() => setShowPayPalModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Pixel56 Template Club Mitgliedschaft</h3>
              <button 
                className="modal-close" 
                onClick={() => setShowPayPalModal(false)}
                aria-label="Modal schließen"
              >
                <X size={24} />
              </button>
            </div>
            <div className="modal-body">
              <p>Sichere dir jetzt deinen Zugang zu täglich neuen Templates mit vollen Resell-Rechten!</p>
              <div className="pricing-summary">
                <div className="price-display">59€ / Monat</div>
                <p>Monatlich kündbar • Sofortiger Zugang</p>
              </div>
              <div id="paypal-button-container"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
